<template>
  <div class="d-flex justify-end align-center ga-4">
    <AGButtonIcon icon="mdi-page-first" size="md" :disabled="isFirstPage" @click="goFirstPage" />
    <AGButtonIcon icon="mdi-chevron-left" size="md" :disabled="isFirstPage" @click="goPreviousPage" />
    <span class="ag-pagination__text"> {{ currentPage }} de {{ totalPages }} {{ text }} </span>
    <AGButtonIcon icon="mdi-chevron-right" size="md" :disabled="isLastPage" @click="goNextPage" />
    <AGButtonIcon icon="mdi-page-last" size="md" :disabled="isLastPage" @click="goLastPage" />
  </div>
</template>

<script>
import AGButtonIcon from '@/components/common/AGButtonIcon';

export default {
  components: {
    AGButtonIcon,
  },
  emits: ['click:first-page', 'click:previous-page', 'click:next-page', 'click:last-page'],
  props: {
    text: {
      type: String,
      default: '',
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    goFirstPage() {
      this.$emit('click:first-page');
    },
    goPreviousPage() {
      this.$emit('click:previous-page');
    },
    goNextPage() {
      this.$emit('click:next-page');
    },
    goLastPage() {
      this.$emit('click:last-page');
    },
  },
};
</script>

<style scoped lang="scss">
.ag-pagination__text {
  font-size: $font-size-xs;
  font-weight: $font-weight-regular;
  color: $neutral-color-high-medium;
}
</style>
